"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import Link from "next/link";
import Icon from "@/components/ui/Icon";
import { DocumentCardLinksCarouselProps } from "./types";
import DocumentCardLink from "../DocumentCardLink";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants";

const DocumentCardLinksCarousel = ({
  className,
  exploreText = "View all documents",
  cards,
}: DocumentCardLinksCarouselProps) => {
  return (
    <>
      <Carousel
        options={{
          slides: {
            spacing: 24,
            perView: "auto",
          },
          breakpoints: {
            "(min-width: 768px)": {
              slides: {
                spacing: 0,
                perView: "auto",
              },
            },
          },
          renderMode: "precision",
        }}
        showNavigation
        className={cn("!overflow-visible md:justify-center", className)}
        navigationClassName="md:hidden"
        navigationSlot={
          <Link
            href={ROUTES.documentsAndDeliverables}
            className="flex-auto py-3 px-8 flex items-center gap-4 min-w-0 border border-blue-500 text-[#2F80ED] text-base leading-[150%] font-semibold md:hidden rounded-3xl"
          >
            <span className="truncate flex-auto min-w-0">{exploreText}</span>
            <Icon
              id="icon-arrow-right-lg_24"
              width={24}
              height={24}
              className="shrink-0 w-6 h-6"
            />
          </Link>
        }
      >
        {cards.map(({ title, href, imageUrl }, index) => {
          return (
            <CarouselSlide
              key={index}
              className="!min-w-[168] !w-[168] md:!min-w-[243] !w-[243] md:last:!min-w-[211] md:last:!w-[211] md:not-last:pr-8"
            >
              <DocumentCardLink
                title={title}
                imageUrl={imageUrl}
                href={href ?? "#"}
              />
            </CarouselSlide>
          );
        })}
      </Carousel>
      <div className="hidden mt-12 text-center md:flex items-center justify-center">
        <Button
          asChild
          variant="primary-outline"
          className="py-3 px-6 h-[48px] w-full sm:w-auto"
        >
          <Link href={ROUTES.documentsAndDeliverables} className="!text-base">
            {exploreText}
          </Link>
        </Button>
      </div>
    </>
  );
};

export default memo(DocumentCardLinksCarousel);
